<template>
  <v-simple-table fixed-header fixed-footer height="350px" class="elevation-0">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Name</th>
          <th class="text-left">Cost</th>
          <th class="text-left">Quantity</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in rawMaterials"
          :key="item.id"
          style="cursor: pointer"
          @click="goToRawMaterial(item.id)"
        >
          <td class="text-left">{{ item.name }}</td>
          <td class="text-left">{{ parseFloat(item.cost).toLocaleString() }}</td>
          <td class="text-left">{{ parseFloat(item.stock - item.used).toLocaleString() }}</td>
        </tr>
        <tr v-if="rawMaterials.length == 0">
          <td colspan="4" style="height:300px;text-align: center">
            No records found
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: ['rawMaterials'],
  data: function() {
    return {};
  },
  methods: {
    goToRawMaterial(id) {
      this.$router.push(`/rawmaterial/${id}`);
    }
  }
};
</script>
